import app from 'general/js/app';

export const awsConfig = {
    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    identityPoolId: app.state.ssoConfig.identityPoolId,

    // REQUIRED - Amazon Cognito Region
    region: app.state.ssoConfig.awsRegion,

    // OPTIONAL - Amazon Cognito Federated Identity Pool Region
    // Required only if it's different from Amazon Cognito Region
    identityPoolRegion: app.state.ssoConfig.awsRegion,

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: app.state.ssoConfig.userPoolId,

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: app.state.ssoConfig.userPoolWebClientId,

    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: true,

    oauth: {
        domain: app.state.ssoConfig.oAuthDomain,
        scope: [
            'email',
            'openid',
            'profile',
            'aws.cognito.signin.user.admin',
            'email'
        ],
        redirectSignIn: app.state.ssoConfig.oAuthRedirectSignIn,
        redirectSignOut: app.state.ssoConfig.oAuthRedirectSignOut,
        responseType: 'code'
    },
    authenticationFlowType: 'USER_PASSWORD_AUTH'
    // OPTIONAL - Configuration for cookie storage
    // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
    /*cookieStorage: {
        // REQUIRED - Cookie domain (only required if cookieStorage is provided)
        domain: app.state.ssoConfig.cookieStorage.domain,
        secure: false
    }*/
};
